import script from "./DownloadCta.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadCta.vue?vue&type=script&setup=true&lang=js"

import "./DownloadCta.vue?vue&type=style&index=0&id=700858ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-700858ca"]])

export default __exports__